// react
import { useState, useRef } from 'react';
// @mui
import {
  IconButton,
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList,
  ClickAwayListener,
} from '@mui/material';
import { MoreVert, Edit } from '@mui/icons-material';
// components
import Iconify from '@/components/minimal/iconify';

//------------------------------------------------------------------

export default function ContentOptions({ onEdit, onDelete }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRef = useRef(null);

  //------------------------------------------------------------------

  //------------------------------------------------------------------
  const handleOpen = () => {
    setAnchorEl(buttonRef.current);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    onEdit();
    handleClose();
  };
  const handleDelete = () => {
    onDelete();
    handleClose();
  };

  return (
    <IconButton
      ref={buttonRef}
      id="composition-button"
      aria-controls={anchorEl ? 'composition-menu' : undefined}
      aria-expanded={anchorEl ? 'true' : undefined}
      aria-haspopup="true"
      onClick={handleOpen}
      className="moreVertSetings"
      aria-label="setting"
    >
      <MoreVert />

      <Popper
        open={Boolean(anchorEl)}
        anchorEl={buttonRef.current}
        role={undefined}
        placement="bottom-start"
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="composition-menu" aria-labelledby="composition-button">
                  <MenuItem onClick={handleEdit}>
                    <Edit
                      sx={{
                        mr: 2,
                        width: 20,
                        height: 20,
                      }}
                    />
                    Edit
                  </MenuItem>
                  <MenuItem onClick={handleDelete} sx={{ color: 'error.main' }}>
                    <Iconify
                      icon={'eva:trash-2-outline'}
                      sx={{
                        mr: 2,
                        width: 20,
                        height: 20,
                      }}
                    />
                    Delete
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </IconButton>
  );
}
